import { NavHeaderDesktop } from "./desktop-nav";
import { ClientHeader } from "./ClientHeader"; // Import the client-side component
import { Logo } from "./logo";
import { useState, useEffect } from "react";

export const excludedIds = [
  271514075209, 271514009673, 276852015177, 266624499785, 278646653001,
];

export const Header = () => {
  const title = process.env.TITLE || "";
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 2);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed z-10 top-0 w-full transition-all duration-300 ${
        isScrolled ? "backdrop-blur-lg bg-black/50" : "bg-black"
      }`}
    >
      <div className="flex justify-between items-center px-4 md:px-8 lg:px-16 py-2 border-b-2 border-red-500">
        {/* Logo */}
        <div className="flex items-center">
          <a href="/" className="flex gap-2 text-marfim text-2xl uppercase tracking-widest">
            <Logo />
          </a>
        </div>

        {/* Título Responsivo */}
        <a
          href="/"
          className="text-marfim text-xl sm:text-2xl uppercase leading-10 tracking-widest drop-shadow-[2px_2px_2px_red] text-center"
        >
          {title}
        </a>

        {/* Menu Desktop */}
        <div className="hidden md:flex">
          <NavHeaderDesktop />
        </div>

        {/* Cliente Header (ajustado para melhor alinhamento) */}
        <div className="ml-auto md:ml-0">
          <ClientHeader />
        </div>
      </div>
    </header>
  );
};
